import { LOAD_CATEGORIES } from './type'
import { firestore } from '../utils/firebase'

export const loadCategories = (payload) => {

    return {
        type: LOAD_CATEGORIES,
        payload: payload
    }
}

export const startLoadCategories = () => (dispatch, getState) => {
    firestore.collection('category').orderBy('updatedAt', 'desc').get().then(snapshot => {
        const categories = {}
        snapshot.forEach(doc => {
            categories[doc.id] = {
                id: doc.id,
                ...doc.data()
            }
        })

        const menu = getState().menu

        // ==================================
        //  making category sections here   
        // ==================================

        for (let key in categories) {
            const catId = categories[key].id
            categories[key].items = []
            for (let menuKey in menu) {
                const menuCats = menu[menuKey].category

                for (let i = 0; i < menuCats.length; i++) {
                    const menuCatValue = menuCats[i].value

                    if (menuCatValue === catId) {
                        categories[key].items.push(menuKey)
                    }
                }
            }
        }

        dispatch(loadCategories(categories))
    })
}

